// extracted by mini-css-extract-plugin
export default {"container":"excerpt-module__container--NxfFI","keyword_highlight":"excerpt-module__keyword_highlight--2zFni","actionBar":"excerpt-module__actionBar--DAQWs"};